import React, { useState } from "react";
import HubHeader from "../HubHeader";
import MACSidebar from "./MACSidebar";
import "../../../assets/css/Hub.css";

export default function MACLandingPage() {
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapseToggle = (next: boolean) => setCollapsed(next);

  return (
    <div className="supportbot-landing-layout">
      <HubHeader />

      <div className="supportbot-landing-body">
        <div
          className={`supportbot-sidebar-wrap ${
            collapsed ? "collapsed" : ""
          }`}
        >
          <MACSidebar
            collapsed={collapsed}
            onCollapseToggle={handleCollapseToggle}
          />
        </div>
        <main className="supportbot-main-content full-width">
          <div className="mac-content-wrapper">
            <header className="amp-header-row">
              <div>
                <h1 className="amp-main-title">MAC</h1>
                <p className="hub-empty-subtitle">
                  Manage your content and configurations
                </p>
              </div>
            </header>

            <div className="mac-main-content">
              <div className="mac-content-card">
        
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
